/** Open Graph / rich-link preview dimensions for contest, campaign, and audition feature images. */
export const RICH_MEDIA_SHARE_WIDTH = 1200;
export const RICH_MEDIA_SHARE_HEIGHT = 630;
export const RICH_MEDIA_SHARE_ASPECT = RICH_MEDIA_SHARE_WIDTH / RICH_MEDIA_SHARE_HEIGHT;
export const RICH_MEDIA_SHARE_MAX_BYTES = 500 * 1024;
export const RICH_MEDIA_SHARE_MAX_INPUT_BYTES = 5 * 1024 * 1024;

/** Short label for inline hints next to upload fields. */
export const RICH_MEDIA_SHARE_SIZE_HINT = '1200×630 · saved under 500KB';

/** Longer helper copy for form descriptions. */
export const RICH_MEDIA_SHARE_SIZE_HINT_LONG = 'Recommended: 1200×630 · max upload 5MB · saved under 500KB · JPG, PNG';
